import { get } from 'lodash';
import { EMPTY_OBJECT } from '../../../../constants/utils';

export const getCounts = state => get(state.marketplace, 'manage.counts', EMPTY_OBJECT);
